import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';

import { Link, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, Typography
} from '@mui/material';

const abEnvironment = new AbEnvironment();
const VendorDashboardTopResellersQuery = graphql`
query VendorDashboardTopResellersQuery ($vendorAccountId: UUID, $totalCount: Int) {
  getvendortopresellers(vendoraccountid: $vendorAccountId, totalcount: $totalCount) {
    nodes {
      accountId
      accountName
      contactLastName
      contactFirstName
      subscriptionCount
      ttlTmBcSum
      ttlTmRebateSum
    }
  }
}
`;

const styleSheet = theme => ({
    paper: {
        marginTop: 16,
        paddingTop: 16,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        // color: theme.palette.text.secondary,
    }
});

class VendorDashboardTopResellers extends Component {
    state = {
    };

    goTo(route) {
      //console.log('route=' + route);
      this.props.history.push(`/${route}`);
    }

    render() {
        const classes = this.props.classes;
        let accountId = abEnvironment.getUserAttribute('a_id');
        let totalCount = 4;

        return (
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={VendorDashboardTopResellersQuery}
            variables={{vendorAccountId: accountId, totalCount: totalCount}}
            render={({error, props})=> {
              if (error) {
                return <div>{error.message}</div>
              } else if (props) {
                
                let resellers = props.getvendortopresellers.nodes;
 
                return ( 
                    <Paper className={classes.paper}>
                      <Typography variant="h6">Top registered partners</Typography>
                      <Typography variant="body2">
                        Top {totalCount} partners by number of subscriptions
                      </Typography>

                      <TableContainer>

                        <Table className={classes.rtable}>
                          <TableHead className={classes.tblHead}>
                            <TableRow className={classes.tblHeadRow}>
                              <TableCell className={classes.tblHeadCell}>Partner</TableCell>
                              <TableCell className={classes.tblHeadCell}>Contact</TableCell>
                              <TableCell className={classes.tblHeadCell}>Subscriptions</TableCell>
                              <TableCell className={classes.tblHeadCell}>Total billed</TableCell>
                              <TableCell className={classes.tblHeadCell}>Total rebated</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {resellers.map(reseller => {
                              
                                let aUrl = "resellervendor?accountId=" + reseller.accountId + "&fp=Dashboard";

                                let totalBilled = Number(reseller.ttlTmBcSum).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                let totalRebates = Number(reseller.ttlTmRebateSum).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                                return (
                                  <TableRow key={reseller.accountName}>
                                    <TableCell>
                                      <Link component="button" 
                                            variant="body2"
                                            className={classes.custlink}
                                            onClick={this.goTo.bind(this, aUrl)}>
                                        {reseller.accountName}
                                      </Link>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2" data-recording-sensitive>{reseller.contactFirstName}&nbsp;{reseller.contactLastName}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2">{reseller.subscriptionCount}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2">{totalBilled}</Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2">{totalRebates}</Typography>
                                    </TableCell>
                                  </TableRow>
                                );
                              } 
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                     </Paper>

                   );
                }
                
              }}
            />
      );
    }
}

export default withStyles(styleSheet)(VendorDashboardTopResellers);